import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const BrandBannerSection = ({ brandInfo }) => {
  const { t } = useTranslation();
  
  return (
    <div className="w-full h-[136px] relative">
      <img 
        src={brandInfo?.cover?.url} 
        alt={brandInfo?.localizedName} 
        className="w-full h-full rounded-md object-cover bg-[#777777]"
      />
      <div className="absolute left-36 top-12 text-white text-2xl font-bold">
        {brandInfo?.localizedName}({brandInfo?.name})
      </div>
      <img 
        src={brandInfo?.logo?.url} 
        alt={brandInfo?.localizedName} 
        className="w-[88px] h-[88px] absolute left-6 top-6 rounded bg-white border border-[#DDDDDD]"
      />
    </div>
  );
};

export default BrandBannerSection; 